import { sanitizeText } from "../utils/index.js";
import { getAddressesFromInput } from "../utils/getAddressesFromInput.js";
import { CustomerType } from "../constants.js";
import { ensurePhoneExternalReference } from "../utils/ensurePhoneExternalReference.js";
const privateCustomerParent = {
    identifier: "privatkunder",
    type: "customerGroup",
};
/**
 * Selects and sanitizes the input for getting customer fields when you have the customer identifier.
 * @param customerInput
 * @param identifier
 */
export const selectCustomerInput = (customerInput, identifier) => {
    const { phone, firstName, lastName, email, addresses, externalReferences, ...customer } = customerInput;
    return {
        ...customer,
        identifier,
        phone: phone ? sanitizeText(phone) : undefined,
        firstName: sanitizeText(firstName),
        lastName: sanitizeText(lastName),
        addresses: getAddressesFromInput(addresses, email ?? undefined),
        email: email ? sanitizeText(email) : undefined,
        parents: customerInput.type === CustomerType.INDIVIDUAL
            ? [privateCustomerParent]
            : undefined,
        // Fallback: ensure "phone" is always present in externalReferences, in case it was not included earlier in the customer object.
        externalReferences: ensurePhoneExternalReference(externalReferences, phone),
    };
};
